(function () {

    'use strict';

    angular
        .module('app.search')
        .factory('ConditionManagerService', [
            '$routeParams',
            ConditionManagerService
        ]);

    function ConditionManagerService($routeParams) {
        function ConditionManager(checkboxConditions, defaultConditionValuesConfig) {
            var that = this;

            this.message = {};
            this.checkboxGroupMessage = {};

            var checkboxNames = {};
            if (checkboxConditions) checkboxConditions.forEach(function (x) {
                checkboxNames[x] = {}
            });

            var defaultConditionValuesActions = [];

            if (!defaultConditionValuesConfig) defaultConditionValuesConfig = [];

            defaultConditionValuesConfig.forEach(function (config) {
                function executeOnce(action) {
                    return function (currRouteParams) {
                        if (!action.hasRun) {
                            action.hasRun = true;
                            action(currRouteParams);
                        }
                    }
                }

                function executeConditionally(action, filter) {
                    return function (currRouteParams) {
                        if (filter())
                            action(currRouteParams);
                    }
                }

                var applyDefaultValue = function (currRouteParams) {
                    that.setCondition(config.cond, config.value);
                };
                if (config.application != "always") {
                    applyDefaultValue = executeConditionally(applyDefaultValue, function () {
                        var setVal = that.getConditionValue(config.cond);
                        return (!setVal || (setVal.length && setVal.length === 0));
                    });
                    if (config.application != "ifNotSet")
                        applyDefaultValue = executeOnce(applyDefaultValue);
                }
                defaultConditionValuesActions.push(applyDefaultValue);
            });


            function CheckboxGroup(name) {
                this.crude = {};
                var that = this;
                this.refined = function () {
                    var checkedValues = [];
                    for (var prop in that.crude) if (that.crude.hasOwnProperty(prop)) if (that.crude[prop])
                        checkedValues.push(prop);
                    return checkedValues;
                };
                this.clear = function () {
                    that.crude = {};
                }
            }

            function initialize() {
                checkboxConditions.forEach(function (condName) {
                    that.checkboxGroupMessage[condName] = that.checkboxGroupMessage[condName] || new CheckboxGroup(condName);
                });

            }

            this.setCondition = function (condName, condVal) {
                if (checkboxNames[condName]) {
                    that.checkboxGroupMessage[condName] = that.checkboxGroupMessage[condName] || new CheckboxGroup(condName);
                    var msg = that.checkboxGroupMessage[condName];
                    msg.crude = {};
                    if (condVal !== undefined) {
                        condVal = [].concat(condVal);
                        condVal.forEach(function (val) {
                            msg.crude[condVal] = true;
                        });
                    }
                }
                else
                    that.message[condName] = condVal;
            };

            this.getConditionValue = function (condName) {
                if (checkboxNames[condName]) {
                    var msg = that.checkboxGroupMessage[condName];
                    if (msg) return msg.refined();
                    else return undefined;
                }
                else
                    return that.message[condName];
            };

            this.clearCondition = function (condName) {
                if (checkboxNames[condName]) {
                    if (that.checkboxGroupMessage[condName]) {
                        that.checkboxGroupMessage[condName].clear();
                        that.checkboxGroupMessage[condName].all = false;
                    }
                }
                else
                    that.message[condName] = undefined;

            };

            this.selectAll = function (cond, criteria) {
                if (!criteria[cond]) return;
                var cgm = that.checkboxGroupMessage[cond];
                for (var ind in criteria[cond]) if (criteria[cond].hasOwnProperty(ind))
                    cgm.crude[criteria[cond][ind].id] = true;
            };

            this.selectSome = function (cond) {
                that.checkboxGroupMessage[cond].all = false;
            };


            this.calculateSearchParams = function (ignoredParam) {
                (function () {
                    for (var i in defaultConditionValuesActions) if (defaultConditionValuesActions.hasOwnProperty(i))
                        defaultConditionValuesActions[i]();
                })();

                function copy(src, dest, filter, extract) {
                    if (!filter) filter = function (p) {
                        return true
                    };
                    if (!extract) extract = function (x) {
                        return x
                    };
                    for (var p in src) if (src.hasOwnProperty(p)) if (src[p] !== undefined) if (filter(p)) {
                        var val = extract(src[p]);
                        if (val !== undefined) dest[p] = val;
                    }
                }

                var searchParams = {};

                copy(that.message, searchParams, function (p) {
                    return (ignoredParam !== p && (ignoredParam + ".l") !== p && (ignoredParam + ".u") !== p);
                });
                copy(that.checkboxGroupMessage, searchParams, function (p) {
                    return (ignoredParam !== p);
                }, function (x) {
                    var val = x.refined();
                    if (val.length !== 0) return val;
                    else return undefined;
                });
                for (var i in that.checkboxGroupMessage) if (that.checkboxGroupMessage.hasOwnProperty(i)) {
                    if (that.checkboxGroupMessage[i].all) searchParams[i + ".all"] = true;
                }
                return searchParams;
            };

            this.updateModel = function (x) {
                var msgInd;
                for (msgInd in that.message) if (that.message.hasOwnProperty(msgInd))
                    delete that.message[msgInd];

                for (msgInd in that.checkboxGroupMessage) if (that.checkboxGroupMessage.hasOwnProperty(msgInd)) {
                    that.checkboxGroupMessage[msgInd].crude = {};
                    delete that.checkboxGroupMessage[msgInd].all;
                }

                initialize();


                for (var k in x) if (x.hasOwnProperty(k)) {
                    // checkboxes
                    if (checkboxNames[k]) {
                        if (x[k + ".all"]) that.checkboxGroupMessage[k].all = true;
                        var values = x[k];
                        if (typeof x[k] === "string")
                            values = x[k].split(",");
                        if (values !== undefined)
                            values.forEach(function (x) {
                                if (x) that.checkboxGroupMessage[k].crude[x] = true;
                            })
                    }
                    else {
                        var regex = /(.*)\.all$/;
                        var pre = regex.exec(k);
                        // 'select all' checkbox
                        if (pre && pre.length >= 2 && checkboxNames[pre[1]])
                            that.checkboxGroupMessage[pre[1]].all = true;
                        // everything else
                        else
                            that.message[k] = x[k];

                    }
                }


                (function () {
                    for (var i in defaultConditionValuesActions) if (defaultConditionValuesActions.hasOwnProperty(i))
                        defaultConditionValuesActions[i]();
                })();


            }
        }

        return {
            createConditionManager: function (checkboxConditions, defaultConditionValuesConfig) {
                return new ConditionManager(checkboxConditions, defaultConditionValuesConfig);
            }
        };
    }

})();


// WEBPACK FOOTER //
// ./app/search/components/service/ConditionManagerService.js